<script lang="ts">
    import { appManager } from "../AppManagerStore";
    import Footer from "../footer/Footer.svelte";
    import StayInformed from "../footer/StayInformed.svelte";
    import Head from "../header/Head.svelte";
    import Navbar from "../header/Navbar.svelte";
    import type { Author } from "./Author";
    import type { Authors } from "./Authors";
    import type { Post } from "./Post";
    import PostCard from "./PostCard.svelte";
    import PostPromoted from "./PostPromoted.svelte";
    import type { Posts } from "./Posts";
    import { _, locale } from "svelte-i18n";

    let allPosts: Post[] = [];
    let posts: Post[] = [];
    let authors: Author[] = [];

    async function load(): Promise<boolean> {
        const response = await fetch(`${$appManager.PublicUrl}data/blog/posts.json`);
        const postsJson = (await response.json()) as Posts;

        allPosts = postsJson.posts;
        allPosts.sort((x, y) => {
            if (x.promoted != y.promoted) {
                if (x.promoted) return -1;
                return 1;
            }
            return -x.date.localeCompare(y.date);
        });

        allPosts.forEach((p) => {
            if (typeof p.translations[$locale] === "undefined") return;

            posts.push(p);
        });

        const authorsResponse = await fetch(
            `${$appManager.PublicUrl}data/blog/authors.json`
        );
        const authorsJson = (await authorsResponse.json()) as Authors;

        authors = authorsJson.authors;

        return true;
    }

    locale.subscribe((ln) => {
        posts = []
        allPosts.forEach((p) => {
            if (typeof p.translations[ln] === "undefined") return;

            posts.push(p);
        });
    });

    function getAuthor(post: Post): Author {
        const result = authors.find((x) => x.id == post.author);
        return result;
    }
</script>

<svelte:head>
    <title>ANYWAYS | {$_("blog.pagetitle")}</title>
</svelte:head>

<Navbar isDark={false} isFluid={false} />

{#await load()}
    <div />
{/await}

{#if authors.length > 0}
    <section class="bg-light px-2">
        <div class="container pl-md-8 pr-md-8">
            <div class="row">
                {#each posts as post, i}
                    {#if i == 0}
                        <PostPromoted {post} author={getAuthor(post)} />
                    {:else}
                        <PostCard {post} author={getAuthor(post)} />
                    {/if}
                {/each}
            </div>
        </div>
    </section>
{/if}

<StayInformed />

<Footer />

<style>
</style>
